var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDocument = function SvgIconDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#092B49",
    d: "m16.063 5.813-4.375-4.375a.57.57 0 0 0-.438-.188H5c-.687 0-1.25.563-1.25 1.25v15c0 .688.563 1.25 1.25 1.25h10c.688 0 1.25-.562 1.25-1.25V6.25a.57.57 0 0 0-.187-.437M11.25 2.75l3.5 3.5h-3.5zM15 17.5H5v-15h5v3.75c0 .688.563 1.25 1.25 1.25H15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#30B7FD",
    d: "M6.25 13.75h7.5V15h-7.5zm0-3.75h7.5v1.25h-7.5z"
  })));
};
export default SvgIconDocument;